import { render, staticRenderFns } from "./ReviewTeamAssignment.vue?vue&type=template&id=4203b493&scoped=true&"
import script from "./ReviewTeamAssignment.vue?vue&type=script&lang=js&"
export * from "./ReviewTeamAssignment.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTeamAssignment.vue?vue&type=style&index=0&id=4203b493&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4203b493",
  null
  
)

export default component.exports